/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_EMPLOYEE_LEAVE_RECORD = `${url}/ LOAD_EMPLOYEE_LEAVE_RECORD`;
export const LOAD_EMPLOYEE_LEAVE_RECORD_SUCCESS = `${url}/ LOAD_EMPLOYEE_LEAVE_RECORD_SUCCESS`;
export const LOAD_EMPLOYEE_LEAVE_RECORD_ERROR = `${url}/ LOAD_EMPLOYEE_LEAVE_RECORD_ERROR`;

export const LOAD_EMPLOYEE_LIST = `${url}/  LOAD_EMPLOYEE_LIST`;
export const LOAD_EMPLOYEE_LIST_SUCCESS = `${url}/  LOAD_EMPLOYEE_LIST_SUCCESS`;
export const LOAD_EMPLOYEE_LIST_ERROR = `${url}/ LOAD_EMPLOYEE_LIST_ERROR`;

export const LOAD_EMPLOYEE_DROPDOWN = `${url}/LOAD_EMPLOYEE_DROPDOWN`;
export const LOAD_EMPLOYEE_DROPDOWN_SUCCESS = `${url}/LOAD_EMPLOYEE_DROPDOWN_SUCCESS`;
export const LOAD_EMPLOYEE_DROPDOWN_ERROR = `${url}/LOAD_EMPLOYEE_DROPDOWN_ERROR`;

export const LOAD_DOCUMENT = `${url}/LOAD_DOCUMENT`;
export const LOAD_DOCUMENT_SUCCESS = `${url}/LOAD_DOCUMENT_SUCCESS`;
export const LOAD_DOCUMENT_ERROR = `${url}/LOAD_DOCUMENT_ERROR`;

export const LOAD_ATTENDANCE_VIEW = `${url}/LOAD_ATTENDANCE_VIEW`;
export const LOAD_ATTENDANCE_VIEW_SUCCESS = `${url}/LOAD_ATTENDANCE_VIEW_SUCCESS`;
export const LOAD_ATTENDANCE_VIEW_ERROR = `${url}/LOAD_ATTENDANCE_VIEW_ERROR`;

export const LOAD_PROJECT_LIST = `${url}/LOAD_PROJECT_LIST`;
export const LOAD_PROJECT_LIST_SUCCESS = `${url}/LOAD_PROJECT_LIST_SUCCESS`;
export const LOAD_PROJECT_LIST_ERROR = `${url}/LOAD_PROJECT_LIST_ERROR`;

const constants = {
  LOAD_EMPLOYEE_LEAVE_RECORD,
  LOAD_EMPLOYEE_LEAVE_RECORD_SUCCESS,
  LOAD_EMPLOYEE_LEAVE_RECORD_ERROR,

  LOAD_EMPLOYEE_LIST,
  LOAD_EMPLOYEE_LIST_SUCCESS,
  LOAD_EMPLOYEE_LIST_ERROR,

  LOAD_EMPLOYEE_DROPDOWN,
  LOAD_EMPLOYEE_DROPDOWN_SUCCESS,
  LOAD_EMPLOYEE_DROPDOWN_ERROR,
 
  LOAD_DOCUMENT,
  LOAD_DOCUMENT_SUCCESS,
  LOAD_DOCUMENT_ERROR,

  LOAD_ATTENDANCE_VIEW,
  LOAD_ATTENDANCE_VIEW_SUCCESS,
  LOAD_ATTENDANCE_VIEW_ERROR,

  LOAD_PROJECT_LIST,
  LOAD_PROJECT_LIST_SUCCESS,
  LOAD_PROJECT_LIST_ERROR,

  LOAD_RECORDS_VALID_CACHE,
};

export default constants;
